import { VotingResultsList } from "./VotingResultsList";

export default VotingResultsList;
